// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"815c065e","453":"a694d1e2","455":"9d9958b0","977":"19d8ca22"}[chunkId] + ".chunk.js";
};